export default __webpack_public_path__ + "static/dagster-5b14825817a6063b910bec798bd0825b.png";